import axios from "../../common/cotAxios";
import {UserData, parseUser} from "../../user/User";
import {FilterResult, UserFilter} from "./models/UserFilter";

export default {
    getAllUserInfo(): Promise<UserData[]> {
        return axios
            .get("/api/user-data")
            .then(({data}) => data.map(parseUser))
            .catch((error) => {
                return error;
            });
    },
    getUserInfo(id: number): Promise<UserData> {
        return axios
            .get(`/api/user-data/${id}`)
            .then(({data}) => data.map(parseUser))
            .catch((error) => {
                return error;
            });
    },
    getUserByFilter(filter: UserFilter): Promise<FilterResult> {
        return axios
            .post(
                "/api/getProfessionalListByConditions",
                {
                    ...( !isNaN(filter.id) && filter.id !== -1 ? {id: filter.id} : {} ),
                    skill: filter.skill,
                    tag: filter.tag
                },
                {
                    withCredentials: true
                }
            )
            .then(({data}) => {
                const result: FilterResult = {
                    professionals: data.professionals,
                    skills: data.skills,
                    tags: data.tags
                };
                return result;
            })
            .catch((error) => {
                return error;
            });
    }
};
